// extracted by mini-css-extract-plugin
module.exports = {"card":"CardStyle_card__pw0uH","name":"CardStyle_name__1m_Qh"};